import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eventi-futuri',
  templateUrl: './eventi-futuri.component.html',
  styleUrls: ['./eventi-futuri.component.css']
})
export class EventiFuturiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
